export default __webpack_public_path__ + "static/media/gallery_02.1357f4e7.jpg";